
import { Link } from 'react-router-dom';
import { AnimatedButton } from '@/components/AnimatedButton';
import { AlertTriangle } from 'lucide-react';

export const UrgencySection = () => {
  return (
    <section className="py-16 bg-emergency-700 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <AlertTriangle size={48} className="mx-auto mb-6 text-amber-300" />
          <h2 className="text-3xl font-bold mb-6">15 Minutes to Readiness</h2>
          <p className="text-xl mb-8 text-white/90">
            Emergencies don't wait for a convenient time. Spend 15 minutes crafting a plan today to protect the people you love, 
            preserve your property, and achieve peace of mind ahead of any crisis.
          </p>
          <p className="text-lg mb-8 text-white/80">
            Get started today with a FREE report.
          </p>
          <Link to="/signup">
            <AnimatedButton className="font-medium bg-amber-400 hover:bg-amber-500 text-black px-8 py-6 text-lg">
              Create Your Plan Today
            </AnimatedButton>
          </Link>
        </div>
      </div>
    </section>
  );
};
